import { css } from "styled-components"

export default css`
	--out-of-range-color: #333;
	--out-of-range-bg-color: ${({ theme }) => theme.colors.platinum};
	--calendar-border: ${({ theme }) => theme.colors.black};
	--cell-border: ${({ theme }) => theme.colors.black};
	--border-color: #ccc;
	--segment-width: 0.14286%;
	--time-selection-color: white;
	--time-selection-bg-color: rgba(0, 0, 0, 0.5);
	--date-selection-bg-color: rgba(0, 0, 0, 0.1);
	--event-bg: ${({ theme }) => theme.colors.paleDogwood};
	--event-bg-1: ${({ theme }) => theme.colors.periwinkle};
	--event-border: #3174ad;
	--event-outline: #3b99fc;
	--event-color: ${({ theme }) => theme.colors.black};
	--event-border-radius: 6px;
	--event-padding: 2px 5px;
	--event-zindex: 4;
	--btn-color: #373a3c;
	--btn-bg: #fff;
	--btn-border: #ccc;
	--current-time-color: #74ad31;
	--today-highlight-bg: #f3dfde;
	--active-background: var(--btn-bg);
	--active-border: var(--btn-border);
`
